import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Icons } from '@monorepo/icons';
import { Card, Flex, TextComponent } from '@monorepo/react-components';
import { IconsNames } from '@monorepo/types';

export const AccountInfoCompact: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { t } = useTranslation(['dashboardTemplates']);

  return (
    <Flex vertical gap={4} className="account-info">
      <Card
        active={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        className={classNames('account-info__trigger', {
          'account-info__trigger--open': isOpen,
        })}
      >
        <Flex justify="space-between">
          <TextComponent level={5} responsive={false}>
            {t('dashboardTemplates:account_info')}
          </TextComponent>

          <TextComponent level={6} responsive={false}>
            <Icons
              className="account-info-chevron"
              iconName={IconsNames.ChevronDown}
            />
          </TextComponent>
        </Flex>
      </Card>
      <div
        className={classNames('account-info__content', {
          'account-info__content--open': isOpen,
        })}
      >
        <Card className="account-info__content-card" active={isOpen}>
          {children}
        </Card>
      </div>
    </Flex>
  );
};
